import React from 'react';
import { WallLiveEditor } from '../live/WallLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function WallBuilder(props: StudioLiveEditorProps) {
  return <WallLiveEditor {...props} />;
}
